<template>
    <div>
      <TriangleHeader :title="$t('profile')"/>
   
      <div class="page-content text-center" style="padding:2rem 0">
        <p>
          <strong>{{user.name}} عزیز خوش آمدید</strong>
        </p>
        <div class="text-center" style="display: flex;justify-content:center">
          <div
          @click="logout"
          class="app-btn my-4"
          style="width: 100px;
height: 40px;"
      >
        <v-progress-circular
            size="30"
            width="4"
            color="white"
            indeterminate
            v-if="loading"
        >

        </v-progress-circular>
        <p class="app-btn" v-else>{{ $t('logout') }}</p>
      </div>
    </div>
      </div>
      <v-snackbar
          :value="error"
          color="warning"
      >
        <p dir="auto" class="snackbar-text">{{$t('wrong_login')}}</p>
      </v-snackbar>
    </div>
  </template>
  
  <script>
    import {
        CHECK_USER
} from "../../store/authManagement/action_type";
  import TriangleHeader from "../../components/triangle_header/TriangleHeader";
import { mapState } from 'vuex';
  export default {
    name: "profile",
    components: {TriangleHeader},
    computed:{
        ...mapState({
          user: state => state.authManagement.user,
        })
    },
    data(){
      return{
       
      }
    },
    methods:{
      logout(){
        this.$store.dispatch(`authManagement/logout`);
        
      }
    },
    created(){
        this.$store.dispatch(`authManagement/${CHECK_USER}`);
    }
  }
  </script>
  
  <style scoped>
  
  </style>